import { FunctionComponent } from 'react'
import { useAppInit } from '../hooks/app'
import { apiService, ApiServiceContext, CommonServicesContext } from '../services'
import { FacadeData, UserAgentString } from '../services/facade'

export interface BasePageProps {
  requestData?: FacadeData
  userAgent?: UserAgentString
}

export const withServices = <T extends object>(
  Component: FunctionComponent<T>
): FunctionComponent<T & BasePageProps> => {
  return ({ requestData, userAgent, ...pageProps }) => {
    const [commonServices] = useAppInit(requestData, userAgent)

    return (
      <ApiServiceContext.Provider value={apiService}>
        <CommonServicesContext.Provider value={commonServices}>
          <Component {...(pageProps as T)} />
        </CommonServicesContext.Provider>
      </ApiServiceContext.Provider>
    )
  }
}
